module.exports = __webpack_public_path__ + "static/media/modelY_Mobile_BackgroundPic.7899c65f.jpg";